export * from './variant-price.component';
